/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

var pageSizeValidator = function pageSizeValidator(pageSize) {
  var pageSizeNumber;
  if (typeof pageSize !== "number") {
    pageSizeNumber = pageSize - 0;
  } else {
    pageSizeNumber = pageSize;
  }
  return !Number.isFinite(pageSizeNumber) && pageSizeNumber > 0;
};

export { pageSizeValidator };
//# sourceMappingURL=validators.js.map
